'use-strict';

/* @ngInject */
export default function MonitoringTaskController(
  $scope,
  $rootScope,
  $route,
  $routeParams,
  monitoringApiService,
  interfaceService,
  fileService,
  commentApiService,
  $location,
  toastService,
) {
  $scope.task = null;
  $scope.completionData = [];
  $scope.sending = false;
  $scope.commentOverlay = false;
  $scope.comments = [];

  /**
   * Upload a single file to the server.
   * @param {File} file
   * @param {string} identifier
   */
  const uploadFile = (file, identifier) => fileService
    .uploadFile(
      file.file,
      identifier,
      file.fileType,
      'sales_documents',
      file.file.name.substr(file.file.name.lastIndexOf('.') + 1),
      file.progressBar,
    );

  /**
   * Gets triggered with form submit.
   * Check if all requried actions are fulfilled by user.
   * Mark the `Task` as 'done';
   */
  $scope.closeTask = async () => {
    const fileUploadPromises = [];
    $scope.sending = true;

    for (const data of $scope.completionData) {
      if (data.action.type === 'file' && data.data.file !== undefined) {
        if ($scope.task.type === 'manual') {
          fileUploadPromises.push(fileService.uploadContextualFile({
            file: data.data.file,
            fileIdentifier: data.data.fileType,
          },
          $scope.task.id,
          'tasks',
          data.data.progressBar));
        } else if ($scope.task.type === 'rule') {
          fileUploadPromises.push(uploadFile(data.data, $scope.task.source_id));
        }
      }
    }

    Promise.all(fileUploadPromises)
      .then(() => monitoringApiService.apiUpdateTaskState($scope.task.id, 'closed'))
      .then(() => {
        toastService.toast('success', 'Erfolgreich abgeschlossen');
        $route.reload();
      })
      .catch((e) => {
        console.error(e);
        $scope.sending = false;
      });
  };

  $scope.finishFormTransmission = (error) => {
    if (!error) $scope.commentOverlay = false;
  };

  $scope.deleteTask = async () => {
    monitoringApiService.apiDeleteTask($scope.task.id)
      .then(() => {
        toastService.toast('success', 'Die Aufgabe wurde gelöscht.');
        $location.path('/');
      })
      .catch((e) => {
        console.error(e);
      });
  };

  /**
   * Get the `Task` for the provided ID.
   * @param {number} taskId
   */
  const init = () => {
    monitoringApiService.apiGetTask($routeParams.taskId)
      .then((task) => {
        $scope.task = task;
        interfaceService.applyScope($scope);
        return commentApiService.getByContext('task', $scope.task.id);
      })
      .then((comments) => {
        $scope.comments = comments;
        interfaceService.applyScope($scope);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  $rootScope.$on('updateComments', () => init());

  $scope.showDeleteDialog = () => {
    $scope.twoStepDelete = true;
    interfaceService.applyScope($scope);
  };

  $scope.hideDeleteDialog = () => {
    $scope.twoStepDelete = false;
  };

  init();
}
